import { youMustConfirm, youHaveRead } from "../utils/common";
var VARIANTS = {
  ARHI: youHaveRead("Privacy Policy Agreement")
};
var validPrivacyPolicyAgreement = function validPrivacyPolicyAgreement(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  if (!value) {
    return youMustConfirm(VARIANTS[funnel] || VARIANTS.ARHI);
  }
  return;
};
export default validPrivacyPolicyAgreement;